import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { PlannerEditorTableViewerFragmentDoc } from './PlannerEditorTable.generated';
import { SettingsPagePlannerFragmentDoc, SettingsPagePlannerSpecialtyFragmentDoc } from '../SettingsPage.generated';
import { SettingsPageCorporationFragmentDoc } from '../SettingsPageCorporationView/SettingsPageCorporationView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPagePlannerViewViewerFragment = { __typename?: 'Viewer', hasLineActivationProvider: boolean, profile: { __typename?: 'PlannerProfile', childrenState: { __typename?: 'ChildrenState', answer: Types.ChildrenStateAnswer, children: Array<{ __typename?: 'Child', birthday: DateString, gender: Types.Gender }> }, address?: { __typename?: 'Address', postalCode: string, prefecture: string, city: string, town: string } | null } };

export type SettingsPagePlannerViewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SettingsPagePlannerViewQuery = { __typename?: 'Query', planner?: { __typename?: 'Planner', id: string, name: string, slug: string, avatar?: any | null, avatarUrl: string, cover?: any | null, coverUrl?: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday?: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> } | null, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> };

export type SettingsPagePlannerCorporationViewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SettingsPagePlannerCorporationViewQuery = { __typename?: 'Query', corporation: { __typename?: 'Corporation', id: string, name: string, branches: Array<{ __typename?: 'Branch', id: string, name: string }> } };

export type UpdatePlannerProfileMutationVariables = Types.Exact<{
  input: Types.UpdatePlannerProfileInput;
}>;


export type UpdatePlannerProfileMutation = { __typename?: 'Mutation', updatePlannerProfile: { __typename?: 'PlannerProfile', comment: string, avatar?: any | null, childrenState: { __typename?: 'ChildrenState', answer: Types.ChildrenStateAnswer, children: Array<{ __typename?: 'Child', birthday: DateString, gender: Types.Gender }> }, address?: { __typename?: 'Address', postalCode: string, prefecture: string, city: string, town: string } | null } };

export type UpdatePlannerMutationVariables = Types.Exact<{
  input: Types.UpdatePlannerInput;
}>;


export type UpdatePlannerMutation = { __typename?: 'Mutation', updatePlanner: { __typename?: 'Planner', id: string, name: string, slug: string, avatar?: any | null, avatarUrl: string, cover?: any | null, coverUrl?: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday?: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> } };

export type IssuePlannerCoverImageUploadUrlMutationVariables = Types.Exact<{
  size: Types.Scalars['Int']['input'];
  contentType: Types.Scalars['String']['input'];
}>;


export type IssuePlannerCoverImageUploadUrlMutation = { __typename?: 'Mutation', issuePlannerCoverImageUploadUrl: { __typename?: 'IssuePlannerCoverImageUploadUrlPayload', uploadURL: string, path: string } };

export type IssuePlannerAvatarImageUploadUrlMutationVariables = Types.Exact<{
  ext: Types.Scalars['String']['input'];
}>;


export type IssuePlannerAvatarImageUploadUrlMutation = { __typename?: 'Mutation', issuePlannerAvatarImageUploadUrl: { __typename?: 'IssuePlannerAvatarImageUploadUrlPayload', uploadURL: string, path: string } };

export const SettingsPagePlannerViewViewerFragmentDoc = gql`
    fragment SettingsPagePlannerViewViewer on Viewer {
  ...PlannerEditorTableViewer
}
    ${PlannerEditorTableViewerFragmentDoc}`;
export const SettingsPagePlannerViewDocument = gql`
    query SettingsPagePlannerView {
  planner {
    ...SettingsPagePlanner
  }
  specialties {
    ...SettingsPagePlannerSpecialty
  }
}
    ${SettingsPagePlannerFragmentDoc}
${SettingsPagePlannerSpecialtyFragmentDoc}`;

/**
 * __useSettingsPagePlannerViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPagePlannerViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPagePlannerViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPagePlannerViewQuery();
 */
export function useSettingsPagePlannerViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>(SettingsPagePlannerViewDocument, {}, options);
}
export function useSettingsPagePlannerViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>(SettingsPagePlannerViewDocument, {}, options);
}
export type SettingsPagePlannerViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPagePlannerViewQuery, SettingsPagePlannerViewQueryVariables>;
export const SettingsPagePlannerCorporationViewDocument = gql`
    query SettingsPagePlannerCorporationView($id: ID!) {
  corporation(id: $id) {
    ...SettingsPageCorporation
  }
}
    ${SettingsPageCorporationFragmentDoc}`;

/**
 * __useSettingsPagePlannerCorporationViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPagePlannerCorporationViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPagePlannerCorporationViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPagePlannerCorporationViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useSettingsPagePlannerCorporationViewQuery(variables: SettingsPagePlannerCorporationViewQueryVariables | VueCompositionApi.Ref<SettingsPagePlannerCorporationViewQueryVariables> | ReactiveFunction<SettingsPagePlannerCorporationViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>(SettingsPagePlannerCorporationViewDocument, variables, options);
}
export function useSettingsPagePlannerCorporationViewLazyQuery(variables?: SettingsPagePlannerCorporationViewQueryVariables | VueCompositionApi.Ref<SettingsPagePlannerCorporationViewQueryVariables> | ReactiveFunction<SettingsPagePlannerCorporationViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>(SettingsPagePlannerCorporationViewDocument, variables, options);
}
export type SettingsPagePlannerCorporationViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPagePlannerCorporationViewQuery, SettingsPagePlannerCorporationViewQueryVariables>;
export const UpdatePlannerProfileDocument = gql`
    mutation UpdatePlannerProfile($input: UpdatePlannerProfileInput!) {
  updatePlannerProfile(input: $input) {
    comment
    avatar
    childrenState {
      answer
      children {
        birthday
        gender
      }
    }
    address {
      postalCode
      prefecture
      city
      town
    }
  }
}
    `;

/**
 * __useUpdatePlannerProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePlannerProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannerProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePlannerProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannerProfileMutation(options: VueApolloComposable.UseMutationOptions<UpdatePlannerProfileMutation, UpdatePlannerProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePlannerProfileMutation, UpdatePlannerProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePlannerProfileMutation, UpdatePlannerProfileMutationVariables>(UpdatePlannerProfileDocument, options);
}
export type UpdatePlannerProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePlannerProfileMutation, UpdatePlannerProfileMutationVariables>;
export const UpdatePlannerDocument = gql`
    mutation UpdatePlanner($input: UpdatePlannerInput!) {
  updatePlanner(input: $input) {
    ...SettingsPagePlanner
  }
}
    ${SettingsPagePlannerFragmentDoc}`;

/**
 * __useUpdatePlannerMutation__
 *
 * To run a mutation, you first call `useUpdatePlannerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePlannerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannerMutation(options: VueApolloComposable.UseMutationOptions<UpdatePlannerMutation, UpdatePlannerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePlannerMutation, UpdatePlannerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdatePlannerMutation, UpdatePlannerMutationVariables>(UpdatePlannerDocument, options);
}
export type UpdatePlannerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePlannerMutation, UpdatePlannerMutationVariables>;
export const IssuePlannerCoverImageUploadUrlDocument = gql`
    mutation issuePlannerCoverImageUploadUrl($size: Int!, $contentType: String!) {
  issuePlannerCoverImageUploadUrl(size: $size, contentType: $contentType) {
    uploadURL
    path
  }
}
    `;

/**
 * __useIssuePlannerCoverImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useIssuePlannerCoverImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssuePlannerCoverImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssuePlannerCoverImageUploadUrlMutation({
 *   variables: {
 *     size: // value for 'size'
 *     contentType: // value for 'contentType'
 *   },
 * });
 */
export function useIssuePlannerCoverImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssuePlannerCoverImageUploadUrlMutation, IssuePlannerCoverImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssuePlannerCoverImageUploadUrlMutation, IssuePlannerCoverImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssuePlannerCoverImageUploadUrlMutation, IssuePlannerCoverImageUploadUrlMutationVariables>(IssuePlannerCoverImageUploadUrlDocument, options);
}
export type IssuePlannerCoverImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssuePlannerCoverImageUploadUrlMutation, IssuePlannerCoverImageUploadUrlMutationVariables>;
export const IssuePlannerAvatarImageUploadUrlDocument = gql`
    mutation issuePlannerAvatarImageUploadUrl($ext: String!) {
  issuePlannerAvatarImageUploadUrl(ext: $ext) {
    uploadURL
    path
  }
}
    `;

/**
 * __useIssuePlannerAvatarImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useIssuePlannerAvatarImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssuePlannerAvatarImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssuePlannerAvatarImageUploadUrlMutation({
 *   variables: {
 *     ext: // value for 'ext'
 *   },
 * });
 */
export function useIssuePlannerAvatarImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssuePlannerAvatarImageUploadUrlMutation, IssuePlannerAvatarImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssuePlannerAvatarImageUploadUrlMutation, IssuePlannerAvatarImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssuePlannerAvatarImageUploadUrlMutation, IssuePlannerAvatarImageUploadUrlMutationVariables>(IssuePlannerAvatarImageUploadUrlDocument, options);
}
export type IssuePlannerAvatarImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssuePlannerAvatarImageUploadUrlMutation, IssuePlannerAvatarImageUploadUrlMutationVariables>;